// extracted by mini-css-extract-plugin
export default {"Characters":"Characters_Characters__nOMVX"};